<div class="s09-panel s09-esig">
  <div class="s09-panel-head">
    <div>
      <h2>Signals</h2>
      <p class="s09-panel-sub">
        Signal groups and reason codes for workflow triggers. Pick codes from patient status dim.
      </p>
    </div>
    <div class="s09-panel-actions">
      <button type="button" class="s09-btn" (click)="newGroup()">New group</button>
      <button type="button" class="s09-btn-create" [disabled]="saving" (click)="saveGroup()">
        {{ saving ? 'Saving…' : 'Save group' }}
      </button>
      <button
        type="button"
        class="s09-btn s09-btn-danger"
        *ngIf="selectedGroupId"
        (click)="deleteGroup()">
        Delete group
      </button>
    </div>
  </div>

  <p class="s09-panel-hint" *ngIf="hint">{{ hint }}</p>
  <p class="s09-panel-hint" *ngIf="loading">Loading signals…</p>

  <div class="s09-esig-grid">
    <aside class="s09-tpl-list">
      <input
        class="s09-tpl-search"
        type="search"
        placeholder="Filter groups…"
        [(ngModel)]="filter" />
      <button
        type="button"
        class="s09-tpl-item"
        *ngFor="let g of filteredGroups"
        [class.active]="g.group_id === selectedGroupId"
        (click)="selectGroup(g)">
        <strong>{{ g.group_label }}</strong>
        <span>{{ g.group_code }}</span>
        <em>{{ (g.signals || []).length }} code{{ (g.signals || []).length === 1 ? '' : 's' }}</em>
      </button>
      <div class="s09-panel-hint" *ngIf="!loading && !filteredGroups.length">No groups.</div>
    </aside>

    <section class="s09-tpl-form">
      <div class="s09-tpl-form-h">
        <h3>{{ selectedGroupId ? 'Edit group' : 'New group' }}</h3>
      </div>

      <div class="s09-field-row">
        <label class="s09-field">
          <span>Group code</span>
          <input
            [(ngModel)]="groupDraft.group_code"
            [readonly]="!!selectedGroupId"
            placeholder="e.g. missing-info" />
        </label>
        <label class="s09-field">
          <span>Sort</span>
          <input type="number" [(ngModel)]="groupDraft.sort_order" />
        </label>
      </div>
      <label class="s09-field">
        <span>Group label</span>
        <input [(ngModel)]="groupDraft.group_label" placeholder="e.g. Missing info (hub / SP)" />
      </label>

      <div class="s09-esig-codes" *ngIf="selectedGroupId">
        <div class="s09-tpl-form-h" style="margin-top:8px">
          <h3>Reason codes in this group</h3>
          <button type="button" class="s09-btn" (click)="startAddSignal()">+ Add code</button>
        </div>

        <div class="s09-esig-code-row" *ngFor="let s of selectedGroup?.signals || []">
          <div class="s09-esig-code-main">
            <span class="s09-code-chip on">{{ s.signal_code }}</span>
            <span [title]="tip(s)">{{ s.signal_label || s.signal_code }}</span>
          </div>
          <div class="s09-esig-code-actions">
            <button type="button" class="s09-btn" (click)="startEditSignal(s)">Edit</button>
            <button type="button" class="s09-btn s09-btn-danger" (click)="deleteSignal(s)">Remove</button>
          </div>
        </div>
        <div class="s09-panel-hint" *ngIf="!(selectedGroup?.signals || []).length">
          No reason codes yet. Click “Add code”.
        </div>
      </div>
      <p class="s09-panel-hint" *ngIf="!selectedGroupId">
        Save the group first, then you can add reason codes from the dim list.
      </p>
    </section>

    <section class="s09-tpl-preview" *ngIf="selectedGroupId">
      <div class="s09-tpl-form-h">
        <div class="s09-tpl-preview-label">
          {{ editingSignalId ? 'Edit reason code' : 'Add reason code' }}
        </div>
        <button type="button" class="s09-btn" *ngIf="signalDraft.signal_code || editingSignalId" (click)="cancelSignalEdit()">
          Clear
        </button>
      </div>

      <div class="s09-field">
        <span>Reason code</span>
        <div class="s09-code-chips" *ngIf="signalDraft.signal_code" style="margin:6px 0">
          <span class="s09-code-chip on">{{ signalDraft.signal_code }}</span>
        </div>
        <small *ngIf="!reasonCodes.length">
          No rows from DU_ANA_PATIENT_STATUS_DIM for this brand. Check grants / brand_key.
        </small>
      </div>

      <label class="s09-field">
        <span>Filter codes</span>
        <input type="search" [(ngModel)]="reasonFilter" placeholder="Type to filter PH02, PS29…" />
      </label>

      <label class="s09-field">
        <span>Description (from dim, editable)</span>
        <input [(ngModel)]="signalDraft.signal_label" placeholder="Description shown in tooltip" />
      </label>

      <label class="s09-field">
        <span>Sort</span>
        <input type="number" [(ngModel)]="signalDraft.sort_order" />
      </label>

      <div class="s09-panel-actions" style="margin-top:8px">
        <button
          type="button"
          class="s09-btn-create"
          [disabled]="saving || !signalDraft.signal_code"
          (click)="saveSignal()">
          {{ editingSignalId ? 'Update code' : 'Add code' }}
        </button>
      </div>

      <div class="s09-esig-reason-list" *ngIf="!editingSignalId">
        <div class="s09-panel-hint" style="margin-bottom:6px">
          Quick pick ({{ filteredReasons.length }} available)
        </div>
        <button
          type="button"
          class="s09-code-chip"
          *ngFor="let r of filteredReasons"
          [class.on]="signalDraft.signal_code===r.reason_code"
          [disabled]="!!editingSignalId"
          [title]="r.reason_desc || r.reason_code"
          (click)="onReasonPick(r.reason_code)">
          {{ r.reason_code }}
        </button>
      </div>
    </section>
  </div>
</div>
